

                if (!window.beaePageJS) {
                    window.beaePageJS = [];
                }
                let jsHandle_nwml4ng1xq = () => {
                    
                        if (document.querySelector('.beae-u6aa8xsk:not([data-beae-bind])')) {
                            (function() {let e=this.$el,t=this.settings_text.type,a=e.querySelector(".beae-mce__text.text-content"),n=this.settings_text.limit?parseInt(this.settings_text.limit):0,s=this.settings_text.view_more_text,o=this.settings_text.content,r="",l=this.settings_text.view_less_text,c=this.settings_text.height;a&&o&&t=="short"&&(r=o.split(" ").filter((m,_)=>_<=n-1).join(" "),r+="...",a.innerHTML=r),setTimeout(()=>{d()},100);function d(){let m=e.querySelector(".beae-element-base-text-view-more");!s||!m||m.addEventListener("click",function(){l&&l.length>0?t=="short"?a.innerHTML.split(" ").length>n?(a.innerHTML=r,m.innerHTML=s):(a.innerHTML=o,m.innerHTML=l):a.style.maxHeight&&a.style.maxHeight!=c?(a.style.maxHeight=c,m.innerHTML=s):(a.style.maxHeight="unset",m.innerHTML=l):(a.innerHTML=o,m.remove())})}}).call({
                                $el: document.querySelector('.beae-u6aa8xsk:not([data-beae-bind])'),
                                settings_text: {"content":"Please direct all inquiries to <b><i>hello@belleboutiqueoc.com</i></b>&nbsp;<div>and we will do our best to get back to you within 2-4 business days&nbsp;</div>"},
                                id: 'beae-u6aa8xsk',
                                isLive: true
                            });
                            document.querySelector('.beae-u6aa8xsk:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                        if (document.querySelector('.beae-h6172v8x:not([data-beae-bind])')) {
                            (function() {if(this.$el){let e=function(){if(!s)return;let o={};if(n.forEach((r,l)=>{let c=!1,d=l==n.length-1;if(l==0)c=window.matchMedia(`only screen and(min-width:${r.min+1}px)`);else{let m=`only screen and(max-width:${r.width}px)${d?"":`and(min-width:${r.min+1}px)`}`;c=window.matchMedia(m)}c&&c.matches&&(o=r)}),Object.keys(o).length){let r=t.querySelector("[data-beae-popup]"),l={},c=this.settings_image.image;if(!r)return;this.settings_image.link==="lightbox"?(this.settings_image.lightbox==="yes"&&(l["data-beae-popup"]="beae-"+Math.random().toString(36).substr(2,8),o.name=="desktop"?l["data-beae-popup-src"]=c.value:l["data-beae-popup-src"]=c[`value__${o.name}`]),o.name=="desktop"?l.href=c.value:l.href=c[`value__${o.name}`]):link==="custom"&&this.settings_image.customLink&&this.settings_image.customLink.href&&Object.assign(l,this.settings_image.customLink),Object.keys(l).length&&Object.keys(l).forEach(d=>{l[d]&&r.setAttribute(d,l[d])})}},t=this.$el,a=t.querySelector(".beae-container-image[data-screens]"),n=[],s="";a&&(s=a.getAttribute("data-screens"),s&&(n=JSON.parse(s))),this.isLive&&this.settings_image&&this.settings_image.link!="none"&&(e.bind(this),window.addEventListener("resize",e.bind(this))),this.settings_image&&this.settings_image.link==="lightbox"&&this.settings_image.lightbox==="yes"&&window.beaejQuery(t).find("[data-beae-popup]").beaePopup({type:"image"})}}).call({
                                $el: document.querySelector('.beae-h6172v8x:not([data-beae-bind])'),
                                settings_image: {"image":{"value":"https://cdn.shopify.com/s/files/1/0905/7628/files/F0A4F906-E1CA-40F7-A272-1E50FD417B69.jpg?v=1689027132","id":"6ahD7iB1","audit":{"type":"image","alt":"F0A4F906-E1CA-40F7-A272-1E50FD417B69","src":"https://cdn.shopify.com/s/files/1/0905/7628/files/F0A4F906-E1CA-40F7-A272-1E50FD417B69.jpg?v=1689027132","elmid":"beae-h6172v8x","width":640,"height":480,"size":96838},"name":"F0A4F906-E1CA-40F7-A272-1E50FD417B69","thumbnail":"https://cdn.shopify.com/s/files/1/0905/7628/files/F0A4F906-E1CA-40F7-A272-1E50FD417B69.jpg?v=1689027132"},"link":"none","lightbox":"no"},
                                id: 'beae-h6172v8x',
                                isLive: true
                            });
                            document.querySelector('.beae-h6172v8x:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                        if (document.querySelector('.beae-5vpfk1yw:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let e=window.innerWidth,t=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=e&&(e=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>t(),500)};t()}).call({
                                $el: document.querySelector('.beae-5vpfk1yw:not([data-beae-bind])'),
                                
                                id: 'beae-5vpfk1yw',
                                isLive: true
                            });
                            document.querySelector('.beae-5vpfk1yw:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                        if (document.querySelector('.beae-fphe5w5e:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let e=window.innerWidth,t=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=e&&(e=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>t(),500)};t()}).call({
                                $el: document.querySelector('.beae-fphe5w5e:not([data-beae-bind])'),
                                
                                id: 'beae-fphe5w5e',
                                isLive: true
                            });
                            document.querySelector('.beae-fphe5w5e:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                        if (document.querySelector('.beae-pxm3gykz:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let e=window.innerWidth,t=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=e&&(e=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>t(),500)};t()}).call({
                                $el: document.querySelector('.beae-pxm3gykz:not([data-beae-bind])'),
                                
                                id: 'beae-pxm3gykz',
                                isLive: true
                            });
                            document.querySelector('.beae-pxm3gykz:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                        if (document.querySelector('.beae-dhsgdxuu:not([data-beae-bind])')) {
                            (function() {let $el = this.$el;
                let limit = this.settings.itemsCount ? this.settings.itemsCount : 8;
                function getToken() {
                    if (window.BEAE && window.BEAE.configs && window.BEAE.configs.instagram) {
                        return window.BEAE.configs.instagram;
                    } else {
                        let token = window.localStorage.getItem('beae-instagram');
                        return token ? token : null;
                    }
                }
                const appendHTML = (medias) => {
                    let html = "";
                    let new_window = this.settings.new_window
                    let link = this.settings.link,
                        lightbox = link === "media" ? this.settings.lightbox : 'no';
    
                 
                        html += medias
                        .map((m) => {
                            let text_caption = ""
                            if(this.settings.overlay_title ==="username") {
                                text_caption = m.username
                            } else if(this.settings.overlay_title === "caption") {
                                text_caption = m.caption
                            } else {
                                text_caption = this.settings?.icon_item
                            }

                            return `<div class="beae-instagram--item ${
                                this.settings.layout === "slider" ? " beae-swiper-slide" : ""
                            }">
                                ${ link ? `<a target="${new_window ? '_blank' : ''}" href="${link === "media" ? m.media : m.url}" ${ lightbox == 'yes' ? `data-beae-popup="gallery"` : ""}>`
                                        : ""
                                }
                                    <figure class="beae-image-default">
                                        <img src="${m.thumb}" alt="${m.username}">

                                        ${

                                            this.settings.overlay_use
                                                ? `<div class="beae-base-instagram-overlay beae-overlay">
                                                ${
                                                    this.settings.overlay_title
                                                    ? `<span class="beae-overlay-text">${text_caption!==undefined?text_caption:''} </span>`
                                                    : ""
                                                }


                                            </div>`
                                                : ""
                                        }
                                    </figure>
                                ${link ? "</a>" : ""}
                            </div>`;
                        })
                        .join("");
                        $el.querySelector(".beae-instagram-wrapper").innerHTML = html;
                   
                    
                };

                const getMedias = (token) => {
                    let kStore = "beae-instagram-" + token;
                    return new Promise((resolve, reject) => {
                        let dataStore = window.localStorage.getItem(kStore);
                        if (dataStore) {
                            let jData = JSON.parse(dataStore);
                            if (jData.exp >= new Date() && jData.data.length >= limit) {
                                resolve(jData.data.slice(0, limit));
                                return false;
                            } else {
                                window.localStorage.removeItem(kStore);
                                getMedias(token).then((response) => resolve(response));
                            }
                        } else {
                            window
                                .fetch(
                                    "https://graph.instagram.com/me/media?" +
                                        new URLSearchParams({
                                            fields: "id,caption,media_url,thumbnail_url,media_type,permalink,username",
                                            access_token: token,
                                            limit
                                        }).toString()
                                )
                                .then((res) => res.json())
                                .then((response) => {
                                    if (response && response.data) {
                                        const getKey = (type, key) => {
                                            let ks = {
                                                image: {
                                                    thumb: "media_url",
                                                    media: "media_url",
                                                    url: "permalink"
                                                },
                                                video: {
                                                    thumb: "thumbnail_url",
                                                    media: "media_url",
                                                    url: "permalink"
                                                },
                                                carousel_album: {
                                                    thumb: "media_url",
                                                    media: "media_url",
                                                    url: "permalink"
                                                }
                                            };
                                            return ks?.[type]?.[key];
                                        };
                                        let datas = response.data.map((item) => {
                                            let type = item.media_type.toLowerCase();
                                            return {
                                                type,
                                                thumb: item[getKey(type, "thumb")],
                                                media: item[getKey(type, "media")],
                                                url: item[getKey(type, "url")],
                                                username: item.username,
                                                caption: item.caption
                                            };
                                        });
                                        window.localStorage.setItem(
                                            kStore,
                                            JSON.stringify({
                                                exp: new Date().setDate(new Date().getDate() + 7),
                                                data: datas
                                            })
                                        );
                                        resolve(datas);
                                    }
                                })
                                .catch((e) => {
                                    reject(e);
                                });
                        }
                    });
                };
                const initSlider = () => {
                    let $container = $el.querySelector(".beae-swiper-container");
                    let options = JSON.parse($container.dataset.optionSwiper);
                    options.pagination.el = $el.querySelector('.beae-swiper-pagination');
                    options.navigation.nextEl = $el.querySelector('.beae-swiper-button-next');
                    options.navigation.prevEl = $el.querySelector('.beae-swiper-button-prev');
                    const params = {
                        allowTouchMove: this.isLive
                    };
                    // options.slidesPerView = 4;
                    new window.BeaeSwiper($container, Object.assign(options, params))
                };
                let token = getToken();
                if (!token) {
                    return false;
                }
                // token demo 'IGQVJYc1V2cS1LRW9pRE5mTXJ0Tjh5V19yaWZAHTUNqd05SQVh2aHE3Ynl0Wjg2aExhWTZA3YmlvVG5JOWRvQ25FajJwQ0dtM1QtSzR3aFhuWVF3aGJ0X3YyZAS1kTEN3cUV5RHI3VTB3'
                getMedias(token)
                    .then((res) => { 
                
                        appendHTML(res);
                        if (this.settings.layout === "slider") {
                            initSlider();
                        }
                        window
                            .jQuery($el)
                            .find("[data-beae-popup]")
                            .beaePopup({
                                type: "image",
                                gallery: {
                                    enabled: true
                                }
                            });
                    })
                    .catch((e) => {
                        console.info(e.message);
                    });}).call({
                                $el: document.querySelector('.beae-dhsgdxuu:not([data-beae-bind])'),
                                settings: {"itemsCount":4,"new_window":true,"link":"instagram","lightbox":"no","overlay_title":"username","layout":"grid","overlay_use":true},
                                id: 'beae-dhsgdxuu',
                                isLive: true
                            });
                            document.querySelector('.beae-dhsgdxuu:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                }
                if (window.beaejQuery) {
                    jsHandle_nwml4ng1xq()
                } else {
                    window.beaePageJS.push(jsHandle_nwml4ng1xq)
                }
            